import { useMutation } from "@tanstack/react-query";
import { http } from "../../../../../services/HttpService";
import { HTTP_ENDPOINTS } from "../../../../../consts/api";

export const useQuickBookTokens = (options = {}) => {
  return useMutation((dto) => {
    return http.post(HTTP_ENDPOINTS.quickBooks.saveQuickBookTokens(), dto);
  }, options);
};
